import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useOutletContext } from "react-router-dom";
import { get_decision_history } from "../services/api";
import { rootRoute } from "../../../config";
import { errorMsg } from "../../../helper/helpers";
import { motion } from "framer-motion";
import prevArrow from "../assets/prevArrow.png";
import leftArrow from "../assets/leftArrow.png";
import rightArrow from "../assets/rightArrow.png";
import clock from "../assets/clock.png";
import target from "../assets/target.png";
import profitreport from "../assets/profitreport.png";
import trophy from "../assets/trophy.png";
import ScmModuleStyle from "../styles/scm.module.css";
import pluralize from 'pluralize';

const DecisionHistory = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const [listOfUsers, setListOfUsers] = useState([]);
  const [simulationDetailSummary, setSimulationDetailSummary] = useState([]);
  const [decisionhistory, setDecisionhistory] = useState([]);
  const [attempt, setAttempt] = useState(queryParams.get("attempt"));
  const [pagination, setPagination] = useState({ prev: false, next: false });
  const [executioninstanceid, setExecutioninstanceid] = useState("");
  const [decisionPageHeight, setDecisionPageHeight] = useState("");
  const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, isPopupShown, setIsPopupShown, accordionPopup, setAccordionPopup, simObj, setSimObj, getMonth, toggleSimulation, setToggleSimulation, startOverSimulation, isLoader, setIsLoader, setAriaProperty, check_Location, setError,] = useOutletContext();
  const noOfRatings = [1, 2, 3, 4, 5];
  const starRating = Number(decisionhistory?.summary?.starRating);
  const TargetSR = simObj?.laststate?.TargetSR;

  let session_id = queryParams.get("sid");
  let resource_id = queryParams.get("resid");
  let course_id = queryParams.get("cid");
  let user_id = queryParams.get("userid");
  let attempt_id = queryParams.get("attempt");
  let role = queryParams.get("role");

  const formatNum = (num) => {
    return num?.toLocaleString("en-US", { style: "decimal" });
  };

  const checkNum = (num, factor) => {
    return num < 0
      ? `-$${Math?.abs(num)?.toLocaleString(undefined, {
        minimumFractionDigits: factor,
        maximumFractionDigits: factor,
      })}`
      : `$${num?.toLocaleString(undefined, {
        minimumFractionDigits: factor,
        maximumFractionDigits: factor,
      })}`;
  };
  const initDecisionHistory = () => {
    (simObj?.status != 'COMPLETED' && (attempt == undefined && user_id == undefined)) && navigate(`${rootRoute}/scm/decisionhistory`);
    window.$("html, body").animate({ scrollTop: 0 }, 100);
    setIsLoader(true);
  };
  const backToSimulationList = () => {
    setIsLoader(true);
    if (role == "student") {
      navigate(rootRoute + `/scm/studentreview?${queryParams}`);
    } else {
      navigate(rootRoute + `/scm/instructorreview?${queryParams}`);
    }
  };
  const getNextAttempt = () => {
    setIsLoader(true);
    let index = simulationDetailSummary?.findIndex(
      (sdObj) => sdObj.attemptno == attempt
    );
    let currSdSObj = simulationDetailSummary[index + 1];
    if (currSdSObj != undefined) {
      setAttempt(currSdSObj.attemptno);
      queryParams.set("attempt", currSdSObj.attemptno);
      setExecutioninstanceid(currSdSObj?.executioninstanceid);
      simulationDetailSummary[index + 2] != undefined
        ? setPagination({ prev: true, next: false })
        : setPagination({ prev: false, next: true });
    } else {
      setPagination({ prev: false, next: true });
      setIsLoader(false);
    }
  };
  const getPrevAttempt = () => {
    setIsLoader(true);
    let index = simulationDetailSummary?.findIndex(
      (sdObj) => sdObj.attemptno == attempt
    );
    let currSdSObj = simulationDetailSummary[index - 1];
    if (currSdSObj != undefined) {
      setAttempt(currSdSObj.attemptno);
      queryParams.set("attempt", currSdSObj.attemptno);
      setExecutioninstanceid(currSdSObj?.executioninstanceid);
      simulationDetailSummary[index - 2] != undefined
        ? setPagination({ prev: false, next: false })
        : setPagination({ prev: true, next: false });
    } else {
      setPagination({ prev: true, next: false });
      setIsLoader(false);
    }
  };
  const OnLoadPagination = () => {
    let lastObjIndex = simulationDetailSummary?.length - 1;
    let firstObjIndex = 0;
    let currentIndex = simulationDetailSummary?.findIndex(
      (sdObj) => sdObj.attemptno == attempt
    );
    currentIndex == lastObjIndex && setPagination({ prev: false, next: true });
    currentIndex == firstObjIndex && setPagination({ prev: true, next: false });
    if (currentIndex != lastObjIndex && currentIndex != firstObjIndex) {
      setPagination({ prev: false, next: false });
    }
  };
  const getSimulationDetailSummary = () => {
    setSimulationDetailSummary(
      attempt != undefined && user_id != undefined
        ? simObj?.simulationdetails
        : []
    );
    setIsLoader(false);
  };
  const updateExcutionInstanceId = () => {
    if (attempt != undefined && user_id != undefined) {
      setExecutioninstanceid(
        simulationDetailSummary?.filter(
          (sdObj) => sdObj.attemptno == attempt
        )[0]?.executioninstanceid
      );
    } else {
      setExecutioninstanceid(simObj?.executioninstanceid);
    }
  };
  const getDecisionHistory = () => {
    (simObj?.sessionid != undefined || session_id != undefined) &&
      executioninstanceid != undefined &&
      executioninstanceid.length > 0 &&
      get_decision_history(simObj?.sessionid || session_id, executioninstanceid)
        .then((response) => {
          if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
            setError(response?.data)
        }
        else{
          setDecisionhistory(response?.data);
          OnLoadPagination();
          setIsLoader(false);
          setIsOverlay(false);
        }
        })
        .catch((error) => {
          // setError(errorMsg);
          setError({"id":"00000","msg":errorMsg})
          console.log(error);
        });
  };

  useEffect(() => {
    updateExcutionInstanceId();
  }, [simulationDetailSummary]);
  useEffect(() => {
    getSimulationDetailSummary();
    if (document.getElementsByClassName(`${ScmModuleStyle["decision-table"]}`)[0] != null) {
      document.getElementsByClassName(
        `${ScmModuleStyle["decision-table"]}`
      )[0].scrollTop = 0;
    }
  }, [attempt]);
  useEffect(() => {
    getDecisionHistory();
  }, [executioninstanceid]);
  useEffect(() => {
    if(document.querySelector("header.header") != null){
      document.querySelector("header.header").style.display = "none";
    }
    // document.querySelector(
    //   `.${ScmModuleStyle["decisionhistory-container"]} header.header h1`
    // ).tabIndex = -1;
    const decisionHistoryPageHeight =
      window.innerHeight -
      document.getElementsByClassName(`${ScmModuleStyle.header}`)[0]
        .clientHeight -
      document.getElementsByClassName(`${ScmModuleStyle.header2}`)[0]
        .clientHeight -
      document.getElementsByClassName(
        `ui grid ${ScmModuleStyle.ui} ${ScmModuleStyle.grid}`
      )[0].clientHeight -
      document.querySelector(`.footer`).clientHeight -
      20;
    setDecisionPageHeight(decisionHistoryPageHeight);
    document.querySelector(".App .row").style.minHeight = "auto";
    document.querySelector(".App").style.overflow = "hidden";
    initDecisionHistory();
    setAttempt(queryParams.get("attempt"));
    // if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
    //   document.querySelector(
    //     "footer.footer .footer-nav .footer-links"
    //   ).style.display = "none";
    // }
    // if (document.querySelector("footer.footer .container") != null) {
    //   document.querySelector("footer.footer .container").style.justifyContent =
    //     "center";
    // }
    if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
      document.querySelector("footer.footer .footer-nav .footer-links").firstChild.style.display = "none";
    }
    document.title = "Supply Chain Management | Decision History";
    setIsOverlay(false);
    return () => {
      document.querySelector(".App .row").style.minHeight = "100vh";
      document.body.style.overflow = "auto";
      if (
        document.querySelector(
          `.${ScmModuleStyle["decisionhistory-container"]} header.header`
        ) != undefined
      ) {
        document.querySelector(
          `.${ScmModuleStyle["decisionhistory-container"]} header.header`
        ).style.display = "block";
      }
      if (
        document.querySelector("footer.footer .footer-nav .footer-links") !=
        null
      ) {
        document.querySelector(
          "footer.footer .footer-nav .footer-links"
        ).style.display = "block";
      }
      if (document.querySelector("footer.footer .container") != null) {
        document.querySelector(
          "footer.footer .container"
        ).style.justifyContent = "space-between";
      }
    };
  }, []);

  return (
    <motion.div
      className={`${ScmModuleStyle["decisionhistory-container"]}`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <header className={`header ${ScmModuleStyle.header}`}>
        <div className={`container ${ScmModuleStyle.container}`}>
          <div className={`${ScmModuleStyle["icon-header-box"]}`}>
            {attempt != undefined && user_id != undefined && (
              <button onClick={backToSimulationList}>
                <img src={prevArrow} />
              </button>
            )}
          </div>
          <h1>Decision History</h1>
        </div>
      </header>
      <div className={`${ScmModuleStyle["decisionhistory-wrapper"]}`}>
        <div className={`${ScmModuleStyle.header2}`}>
          <h3>
            {attempt != undefined &&
              `Supply Chain Management Simulation (Attempt ${attempt})`}
          </h3>

          <div>
            {attempt != undefined &&
              user_id != undefined &&
              simulationDetailSummary?.length != 1 && (
                <div className={`${ScmModuleStyle["pagination-icons"]}`}>
                  <button disabled={pagination.prev} onClick={getPrevAttempt}>
                    <img src={leftArrow} />
                  </button>
                  <button disabled={pagination.next} onClick={getNextAttempt}>
                    <img src={rightArrow} />
                  </button>
                </div>
              )}
          </div>
        </div>
        <div className={`ui grid ${ScmModuleStyle.ui} ${ScmModuleStyle.grid}`}>
          <div className={`column ${ScmModuleStyle.column}`}>
            <img src={clock} />
            <span>
              {decisionhistory?.summary?.startday}-
              {decisionhistory?.summary?.endday}
            </span>
            <p>Simulation Started - Ended</p>
          </div>
          <div className={`column ${ScmModuleStyle.column}`}>
            <img src={target} />
            <span>{checkNum(Number(decisionhistory?.summary?.remainingBudget))}</span>
            <p>Remaining Budget</p>
          </div>
          <div className={`column ${ScmModuleStyle.column}`}>
            <img src={target} />
            <span>{formatNum(decisionhistory?.summary?.gizmoManufactured)}</span>
            <p>{(decisionhistory?.userData && decisionhistory?.userData != "") ? (decisionhistory?.userData) : "Gizmos"} Manufactured</p>
          </div>
          <div className={`column ${ScmModuleStyle.column}`}>
            <img src={trophy} />
            <span>{decisionhistory?.summary?.customerMorale}</span>
            <p>Customer Morale</p>
          </div>

          <div className={`column ${ScmModuleStyle.column}`}>
            <img src={trophy} />
            <span>{decisionhistory?.summary?.status}</span>
            <p>Target Achieved</p>
          </div>
          <div className={`column ${ScmModuleStyle.column}`}>
            <img src={trophy} />
            <span>{decisionhistory?.summary?.score}%</span>
            <p>Score</p>
          </div>
        </div>

        <div
          className={`${ScmModuleStyle["decision-table"]}`}
          style={{ height: decisionPageHeight + "px" }}
        >
          <table
            className={`ui unstackable table ${ScmModuleStyle.ui} ${ScmModuleStyle.unstackable} ${ScmModuleStyle.table}`}
          >
            <thead>
              <tr>
                <th className={`column`}>Simulation Duration</th>
                <th className={`column`}>Decisions Made</th>
                <th className={`column`}>Procurement Cost ($)</th>
                <th className={`column`}>Units Received</th>
                <th className={`column`}>{(decisionhistory?.userData && decisionhistory?.userData != "") ? (decisionhistory?.userData) : "Gizmos"} Manufactured</th>
                <th className={`column`}>Customer Morale</th>
              </tr>
            </thead>

            <tbody>
            {decisionhistory?.detail?.map((detailObj, index) => (
              <tr key={index + "_04"}>
                <td>{detailObj?.simulationPeriod}</td>
                <td className={`${ScmModuleStyle["investment-list"]}`}>
                      <ol className={`${ScmModuleStyle["decision-list"]}`} >
                      {
                      detailObj?.bidrequest != "" && <li>{detailObj?.bidrequest}</li>
                      }
                      {
                      detailObj?.cancelorder != "" && <li>{detailObj?.cancelorder}</li>
                      }
                      {
                      detailObj?.placeorder != "" && <li>{detailObj?.placeorder}</li>
                      }
                      </ol>
                </td>
                <td>
                  {checkNum(detailObj?.totalProcurementCost)}
                </td>
                <td>
                  <div>1) SKU 1 - <strong>{detailObj?.SKU_1}</strong></div>
                  <div>2) SKU 2 - <strong>{detailObj?.SKU_2}</strong></div>
                </td>
                <td>{formatNum(detailObj?.gizmoManufactured)}</td>
                <td>{detailObj?.customerMorals}</td>
              </tr>
            ))}
            </tbody>
          </table>
        </div>
      </div>
    </motion.div>
  );
};

export default DecisionHistory;
